import { RestrictionMap } from "@/modules/restriction";
import { Wrapper } from "components/layout";

export function RestrictionPage() {
  return (
    <Wrapper title="Arrêtés Municipaux" className="mask-background">
      <RestrictionMap />
    </Wrapper>
  );
}
